'use client'
import { useRouter } from 'next/navigation'

import { PATHS } from 'shared/utils/paths'

import CheckoutProgressBarItem from './CheckoutProgressBarItem'

import styles from './CheckoutProgressBar.module.scss'

interface CheckoutProgressBarProps {
  activeStep: number
}

const CheckoutProgressBar = ({ activeStep }: CheckoutProgressBarProps) => {
  const router = useRouter()

  const redirectHandler = (step: number, path: string) => async () => {
    if (step !== activeStep && path !== PATHS.payment) {
      router.push(path)
    }
  }
  // @sieradz - make a cart fetch at each step in the shopping cart
  // (helps with substitutions and delivery)

  return (
    <div
      className={styles.wrapper}
      aria-label='Progres zakupu'
      role='progressbar'
    >
      <CheckoutProgressBarItem
        onClick={redirectHandler(1, PATHS.cart)}
        label='Koszyk'
        stepNumber={1}
        activeStep={activeStep}
      />
      <div className={styles.divider} />
      <CheckoutProgressBarItem
        onClick={redirectHandler(2, PATHS.delivery)}
        label='Dostawa'
        stepNumber={2}
        activeStep={activeStep}
      />
      <div className={styles.divider} />
      <CheckoutProgressBarItem
        onClick={redirectHandler(3, PATHS.payment)}
        label='Płatność'
        stepNumber={3}
        activeStep={activeStep}
      />
    </div>
  )
}

export default CheckoutProgressBar
